import { createRouter, createWebHistory } from 'vue-router'
import { useSessionStore } from '@/stores/session'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: () => import('@/pages/LoginPage.vue'), meta: { public: true } },
    { path: '/change-password', name: 'change-password', component: () => import('@/pages/ChangePasswordPage.vue') },
    {
      path: '/', component: () => import('@/components/AppShell.vue'),
      children: [
        { path: '', name: 'dashboard', component: () => import('@/pages/DashboardPage.vue') },
        { path: 'projects', name: 'projects', component: () => import('@/pages/ProjectsPage.vue'), meta: { roles: ['admin', 'storekeeper'] } },
        { path: 'parts', name: 'parts', component: () => import('@/pages/PartsPage.vue'), meta: { roles: ['admin', 'storekeeper'] } },
        { path: 'suppliers', name: 'suppliers', component: () => import('@/pages/SuppliersPage.vue'), meta: { roles: ['admin', 'storekeeper'] } },
        { path: 'purchases', name: 'purchases', component: () => import('@/pages/PurchasesPage.vue'), meta: { roles: ['admin', 'storekeeper'] } },
        { path: 'custody', name: 'custody', component: () => import('@/pages/CustodyPage.vue') },
        { path: 'installations', name: 'installations', component: () => import('@/pages/InstallationsPage.vue'), meta: { roles: ['admin', 'storekeeper'] } },
        { path: 'reports', name: 'reports', component: () => import('@/pages/ReportsPage.vue'), meta: { roles: ['admin', 'storekeeper'] } },
        { path: 'users', name: 'users', component: () => import('@/pages/UsersPage.vue'), meta: { roles: ['admin'] } },
        { path: 'audit', name: 'audit', component: () => import('@/pages/AuditPage.vue'), meta: { roles: ['admin'] } },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  const session = useSessionStore()
  if (!session.ready) await session.restore()
  if (!to.meta.public && !session.user) return { name: 'login', query: { redirect: to.fullPath } }
  if (to.meta.public && session.user) return { name: 'dashboard' }
  if (session.user?.must_change_password && to.name !== 'change-password') return { name: 'change-password' }
  if (session.user && !session.user.must_change_password && to.name === 'change-password') return { name: 'dashboard' }
  const roles = to.meta.roles as string[] | undefined
  if (roles && session.user && !roles.includes(session.user.role)) return { name: 'dashboard' }
  return true
})

export default router
